'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = select;
exports.show = show;
exports.hide = hide;
exports.selectList = selectList;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW = 'select/SHOW';
var HIDE = 'select/HIDE';
var SELECTED = 'select/SELECTED';

var initialState = {
  show: false,
  selected: '',
  ref: ''
};

function select() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW:
      return (0, _extends3.default)({}, state, {
        show: true,
        ref: action.ref
      });
    case HIDE:
      return (0, _extends3.default)({}, state, {
        show: false,
        ref: action.ref
      });
    case SELECTED:
      return (0, _extends3.default)({}, state, {
        selected: action.selected
      });
    default:
      return state;
  }
}

function show(ref) {
  return {
    type: SHOW,
    ref: ref
  };
}
function hide(ref) {
  return {
    type: HIDE,
    ref: ref
  };
}
function selectList(selected) {
  return {
    type: SELECTED,
    selected: selected
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/select.js
// module id = 104
// module chunks = 0